import { Close } from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import React from "react";
import { withTranslation } from "react-i18next";
import {ExtraBold,SemiBold,Regular} from "../../utils/constants"
import { DialogDrawer } from "../dialogdrawer";
const useStyles = makeStyles((theme) => ({
  content: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
  },
  img: {
    height: "210px",
    width: "210px",
  },
  title: {
    fontSize: "1.25rem",
    fontFamily: ExtraBold,
    color: "#091B29",
    textAlign: "center",
  },
  subTitle: {
    fontSize: "0.875rem",
    fontFamily: Regular,
    textAlign: "center",
    color: "#4E5A6B",
  },
  subTitle2: {
    fontSize: "0.875rem",
    fontFamily: SemiBold,
    textAlign: "center",
    color: "#4E5A6B",
  },
  contactCard: {
    width: "291px",
    height: "71px",
    padding: "13px",
    boxShadow: "0px 3px 30px #4354721F",
    borderRadius: "12px",
  },
  cardImg: {
    width: "45px",
    height: "45px",
  },
  servicesubTitle2:{
    fontFamily: SemiBold,
    fontSize: "0.875rem",

  }
}));
const CommunityMemberModel = ({ t = () => false, onClose,open }) => {
  const classes = useStyles();
  return (
    <DialogDrawer
    open={open}
    isnotTitle
    onClose={onClose}
    height={"auto"}
    component={
      <Box>
      <Typography align="right" onClick={onClose}>
        <Close sx={{ color: "#00000080" }} />
      </Typography>
      <Box className={classes.content}>
        <img className={classes.img} src="/images/not_available.svg" alt="member" />
        <Box height={"20px"} />
        <Typography className={classes.subTitle}>
          {t("Seems like you don't have")}
        </Typography>
        <Typography className={classes.title}>{t("Community Membership")}</Typography>
        <Typography className={classes.subTitle}>
          {t("to avail this service")}
        </Typography>
        <Box height={"10px"} />
        <Box className={classes.contactCard}>
          <Grid container justifyContent={"center"} alignItems={"center"}>
            <Grid item xs={2}>
              <img className={classes.cardImg} src="/images/not_available_persion.svg" alt="person" />
            </Grid>
            <Grid item xs={10}>
              <Typography sx={{marginInlineStart:2}} className={classes.servicesubTitle2}>
                {t("Please contact your property manager for membership")}
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <Box height={"20px"} />
      </Box>
    </Box>
    }
    />
   
  );
};

export default withTranslation("common")(CommunityMemberModel);
